<template>
  <article class="accordion">
    <div class="accordion-header">
      <h3 class="is-size-5 has-text-weight-bold">Review <img src="@/assets/img/yup.png"/></h3>
      <span class="action hover-text-primary" @click="edit('')">EDIT</span>
    </div>
    <div class="accordion-body">
      <div class="accordion-content">
        <div class="checkout-accordion-content-wrap">
          <h3 class="accordion-title is-size-5 has-text-weight-bold">Review</h3>
          <div class="checkout-accordion-content">
            
            <h3 class="is-size-5 has-text-weight-semibold mb10">Order:</h3>
            <div class="checkout-review-order checkout-review-accordion">
              <div class="content-box tax-price">
                
                <table class="cart-table">
                  <tr v-bind:key="'cart_table_item_' + index" v-for="(product, index) in vg_cartItems">
                    <td class="td-product-name is-size-14">{{ product.product_name }}</td>
                    <td
                      class="td-product-info text-right is-size-14"
                    >{{ product.selected_variant.weight_equivalent_dry_cannabis }}{{ product.weighing_unit ? product.weighing_unit : '' }} X {{ product.unit }}</td>
                    <td
                      class="td-product-price text-right is-size-14"
                    >
                      <span v-if="hasSalePrice(product)" class="opacity-8 "><s class="opacity-03">${{ (product.unit * product.selected_variant.price).toFixed(2)}}</s><br/></span>
                      ${{ (product.unit * product.price).toFixed(2) }}
                    </td>
                  </tr>
                </table>
              </div>

              <div class="content-box subtotal-box pt-10">
                <div class="level is-mobile mb5" v-if="!vg_is_greenline_pos">
                  <div class="level-left">
                    <div class="level-item">
                      <p class="sf-pro-text-regular is-size-14 ">Subtotal</p>
                    </div>
                  </div>
                  <div class="level-right">
                    <div class="level-item">
                      <p class="sf-pro-text-regular  is-size-14">
                        <!-- <span class="subtotal-without-sale-price" v-if="activeSalePriceData.hasActiveSale">
                          <s class="opacity-03">${{ activeSalePriceData.regularPrice}}</s>
                        </span> -->
                        <span :class="(vg_cartPromoCode || vg_cartLoyality) ? 'strike': ''">${{ vg_cartSubTotal }}</span>
                      </p>
                    </div>
                  </div>
                </div>

                <div class="level is-mobile mb5" v-if="vg_is_greenline_pos">
                  <div class="level-left">
                    <div class="level-item">
                      <p class="sf-pro-text-regular is-size-14">Deposit</p>
                    </div>
                  </div>
                  <div class="level-right">
                    <div class="level-item">
                      <p class="sf-pro-text-regular is-size-14">
                        ${{ vg_greenlineProductDeposit }}
                      </p>
                    </div>
                  </div>
                </div>

                <div class="level is-mobile mb5" v-if="vg_cartPromoCode">
                  <div class="level-left">
                    <div class="level-item">
                      <p class="sf-pro-text-regular is-size-14">Promo Code: {{ vg_cartPromoCode.code}}</p>
                    </div>
                  </div>
                  <div class="level-right">
                    <div class="level-item">
                      <p class="sf-pro-text-regular text-green is-size-14">
                        - ${{ vg_cartPromoCode.applied_value.toFixed(2) }} 
                      </p>
                    </div>
                  </div>
                </div>

                <div class="level is-mobile mb5" v-if="vg_cartLoyality">
                  <div class="level-left">
                    <div class="level-item">
                      <p class="sf-pro-text-regular is-size-14">Points Used: {{ new Intl.NumberFormat().format(vg_cartLoyality.points_to_redeem) }}</p>
                    </div>
                  </div>
                  <div class="level-right">
                    <div class="level-item">
                      <p class="sf-pro-text-regular text-green is-size-14">
                        - ${{ vg_cartLoyality.redeem_amount.toFixed(2) }} 
                      </p>
                    </div>
                  </div>
                </div>

                <div class="level is-mobile mb5" v-if="!vg_is_greenline_pos && (vg_cartPromoCode || vg_cartLoyality)">
                  <div class="level-left">
                    <div class="level-item">
                      <p class="sf-pro-text-regular is-size-14 ">New Subtotal</p>
                    </div>
                  </div>
                  <div class="level-right">
                    <div class="level-item">
                      <p class="sf-pro-text-regular text-green is-size-14">
                        ${{ vg_newSubTotal }}
                      </p>
                    </div>
                  </div>
                </div>

                <div class="level is-mobile mb5">
                  <div class="level-left">
                    <div class="level-item">
                      <p class=" sf-pro-text-regular is-size-14 ">Tax</p>
                    </div>
                  </div>
                  <div class="level-right">
                    <div class="level-item">
                      <p class=" sf-pro-text-regular is-size-14 ">${{ vg_cartTax ? vg_cartTax : 0.00 }}</p>
                    </div>
                  </div>
                </div>

                <div class="level is-mobile mb5" v-if="vg_checkoutOrderType.order_receive_method == 'delivery'">
                  <div class="level-left">
                    <div class="level-item">
                      <p class=" sf-pro-text-regular is-size-14 ">Delivery Fee</p>
                    </div>
                  </div>
                  <div class="level-right">
                    <div class="level-item">
                      <p
                        class=" sf-pro-text-regular  is-size-14"
                      >${{ parseFloat(vg_checkoutOrderType.delivery_fee).toFixed(2) }}</p>
                    </div>
                  </div>
                </div>

                <div class="level is-mobile mb5" v-if="vg_checkoutOrderType.order_receive_method == 'delivery' && vg_selectedStore.settings && vg_selectedStore.settings.delivery_orders && vg_selectedStore.settings.delivery_orders.enable_tips">
                  <div class="level-left">
                    <div class="level-item">
                      <p class=" sf-pro-text-regular is-size-14 ">Tip</p>
                    </div>
                  </div>
                  <div class="level-right">
                    <div class="level-item">
                      <p
                        class=" sf-pro-text-regular  is-size-14"
                      >${{ parseFloat(vg_checkoutOrderType.tip).toFixed(2) }}</p>
                    </div>
                  </div>
                </div>

            
                <div class="level is-mobile mb5">
                  <div class="level-left">
                    <div class="level-item">
                      <p class="is-size-16 has-text-weight-bold ">Total</p>
                    </div>
                  </div>
                  <div class="level-right">
                    <div class="level-item">
                      <p v-if="vg_is_greenline_pos || vg_is_tendy_pos" class="is-size-16 has-text-weight-bold">${{ vg_cartGrandTotal }}</p>
                      <p v-else class="is-size-16 has-text-weight-bold">${{ vg_checkoutOrderType.order_receive_method == 'pickup' ? vg_cartGrandTotal : cartGrandTotalWithDelivery.toFixed(2) }}</p>
                    </div>
                  </div>
                </div>

                <div class="level is-mobile" v-if="enabledLoyality">
                  <div class="level-left">
                    <div class="level-item">
                      <p class="is-size-16 has-text-weight-bold ">Points Earned</p>
                    </div>
                  </div>
                  <div class="level-right">
                    <div class="level-item">
                      <p class="is-size-16 has-text-weight-bold ">{{ vg_cartLoyalityPointsObj.points_earned ? new Intl.NumberFormat().format(vg_cartLoyalityPointsObj.points_earned) : 0 }} pts</p>
                    </div>
                  </div>
                </div>

              </div>
            </div>


            <!-- Order type -->
            <div class="review-order-type-wrapper">
              <h3 class="is-size-5 has-text-weight-semibold mb10">Order Type:</h3>
              <div class="review-order-type-content">
                <div class="review-order-type-left">
                  <p class="has-text-weight-bold is-size-14 is-capitalized">{{ this.vg_checkoutOrderType.order_receive_method }}</p>
                </div>
                <div class="review-order-type-right">
                  <p class="has-text-weight-bold is-size-14">{{ this.vg_checkoutOrderType.pickupTime }}</p>
                </div>
              </div>
              <div class="review-order-type-content">
                <div class="review-order-type-left">
                  <location-selected :headingclass="''"/>
                </div>
                <div class="review-order-type-right">
                  <p class="is-size-14">{{ this.vg_checkoutOrderType.delivery.address1 }}</p>
                </div>
              </div>
            </div>

            <!-- Payment -->
            <div class="review-order-type-wrapper border-none mt0">
              <h3 class="is-size-5 has-text-weight-semibold mb10">Payment:</h3>
              <div class="review-order-type-content">
                <div class="review-order-type-left">
                  <p class="is-size-14">{{ vg_checkoutPayment.pay_later ? ( vg_checkoutOrderType.order_receive_method == 'pickup' ? 'Pay at store' : 'Pay at door') : 'Pay now' }}</p>
                </div>
              </div>
            </div>


             <!-- <div class="review-order-type-wrapper mb20 mt0" v-if="!this.vg_userId">
              <h3 class="is-size-5 has-text-weight-semibold mb10">Captcha:</h3>
              <div class="review-order-type-content review-captcha-wrap">
                <vue-recaptcha ref="recaptcha"
                :loadRecaptchaScript="true"
                  @verify="onVerify" @expired="expiredCaptcha" sitekey="6LenodUmAAAAAC3kPGJv4CYlsnBgIFNqjBWlVYzQ">
                </vue-recaptcha>
            
                 <div class="review-order-type-left mt5">
                  <div class="captcha-wrapper is-flex">
                    <a class="reload-captcha bg-secondary text-white hover-opacity-7" href="#" @click.prevent="generateCaptcha()">
                      <i class="fas fa-sync-alt"></i>
                    </a>
                    <div class="mt7px">
                      <canvas v-for="item in captchaCanvas" v-bind:key="'canvas'+item" :id="item" width="25" height="25"></canvas>
                    </div>
                  </div>
                </div>
                <div>
                  <input  
                    class="input mt5"
                    name="captcha"
                    type="text"
                    v-model="confirmCaptchCode"
                    placeholder="Write Captcha Code"
                  />
                </div> 
              </div>
            </div> -->
            
            <p class="text-primary" v-if="vg_loyalityPointsNotice" v-html="vg_loyalityPointsNotice"></p>

            <div class="accordion-action mt20 accordion-flex-action">
              <p>By submitting an order, you agree to the Budler <router-link class="hover-text-primary" target="_blank" :to="{ name: 'TermsConditions', params: { business_slug: $route.params.business_slug }, query: $route.query }">Terms of Use</router-link> and <router-link class="hover-text-primary" target="_blank" :to="{ name: 'PrivacyPolicy', params: { business_slug: $route.params.business_slug }, query: $route.query }">Privacy Policy</router-link></p>
              <a
              @click.prevent="submitOrder()"
              href="#"
              class="button bg-secondary btn-complete hover-opacity-7 text-white"
              >
                SUBMIT ORDER
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </article>
</template>


<script>
import CartApis from '@/Components/Controllers/CartApis';
import { mapGetters, mapActions, mapMutations } from "vuex";
import Helpers from '@/Components/Helpers/Helpers';
import LocationSelected from '@/Components/Pages/Inc/SelectedLocation';
import moment from 'moment';
import ProductApis from '@/Components/Controllers/ProductApis';
import CheckoutApis from '@/Components/Controllers/CheckoutApis';
import VboutApis from '@/Components/Controllers/VboutApis';
import OrderHistoryApis from '@/Components/Controllers/OrderHistoryApis';
import UserApis from '@/Components/Controllers/UserApis';

export default {
  name: 'CheckoutOrderSummary',
  components: {
    LocationSelected
  },
  data() {
    return {
      orderConfirmDetail: {},
      // captchaCanvas: ['can1', 'can2', 'can3', 'can4'],
      // captchCode: '',
      // confirmCaptchCode: '',
      // captchaVerified: false,
    };
  },
  computed: {
    ...mapGetters({
      vg_cartId: "cart/id",
      vg_userId: "getLoggedInUserId",
      vg_businessprofile: "businessprofile/detail",
      vg_cartItems: "cart/cartItems",
      vg_selectedStore: "location/selected",
      vg_cartSubTotal: "cart/cartSubTotal",
      vg_newSubTotal: "cart/newSubTotal",
      vg_is_greenline_pos: "location/is_greenline_pos",
      vg_greenlineProductDeposit: "cart/greenline_product_deposit",
      vg_cartTax: "cart/cartTax",
      vg_cartPromoCode: "cart/promocode",
      vg_is_tendy_pos: "location/is_tendy_pos",
      vg_cartGrandTotal: "cart/cartGrandTotal",
      vg_weightOnCart: "cart/cartWeight",
      vg_cannabisLimit: "location/cannabis_limit",
      vg_guestLandedQueries: "location/guestLandedQueries",
      vg_checkoutOrderType: "checkout/ordertype",
      vg_checkoutPayment: "checkout/payment",
      vg_cartLoyality: "cart/loyality",
      vg_hasBusinessLoyalityProgram: "businessprofile/hasBusinessLoyalityProgram",
      vg_userLoyalitySubscription: "userloyalitysubscription/subscribed",
      vg_cartLoyalityPointsObj: "cart/loyalityPointsObj",
      vg_loyalityPointsNotice: "cart/loyalityPointsNotice",
    }),

    enabledLoyality() {
      if(this.vg_userId && this.vg_userLoyalitySubscription && this.vg_hasBusinessLoyalityProgram){
        return true;
      }
      return false;
    },

    kioskMode() {
      return (this.$route.query['kiosk'] && ( (this.$route.query['kiosk'] == 1) || (this.$route.query['kiosk'] == 'true') ) ) ? true : false;
    },

    activeSalePriceData() {
      let hasActiveSale = false;
      let regularPrice = 0;
      this.vg_cartItems.map(item => {
        if(parseFloat(item.selected_variant.sale_price) > 0 && parseFloat(item.selected_variant.sale_price) < parseFloat(item.selected_variant.price)){
          hasActiveSale = true;
        } 
        regularPrice += item.unit * item.selected_variant.price;
      })
      return {
        hasActiveSale,
        regularPrice: regularPrice.toFixed(2)
      };
    },

    cartGrandTotalWithDelivery() {
      return parseFloat(this.vg_cartGrandTotal) + parseFloat(this.vg_checkoutOrderType.delivery_fee) + parseFloat(this.vg_checkoutOrderType.tip);
    },

  },
  mounted() {
    
    //this.generateCaptcha();

  },
  // beforeDestroy() {
  //   bus.$off('checkout-step');
  // },

  methods: {
    /**
     * generate captcha
     */
    // generateCaptcha() {
      
    //   let text = Helpers.generateRandomText(4);
    //   this.captchCode = text;
    //   let chars = text.split('');
    //   chars.shift();
   
    //   this.captchaCanvas.forEach( (i, index) => {
    //     var c = document.getElementById(i);
    //     var ctx = c.getContext("2d");
    //     ctx.clearRect(0, 0, c.width, c.height);
    //     ctx.font = "20px Arial";
    //     if(index % 2 == 0 ) {
    //       ctx.fillStyle = "grey";
    //       c.style.transform = 'rotate(-20deg)';
    //     }
    //     ctx.fillText(chars[index],0,20);

    //   })
  
    // },

    /**
     * Submit order
     */
    async submitOrder() {


      if( parseFloat(this.vg_weightOnCart) > parseFloat(this.vg_cannabisLimit) ){
        bus.$emit('show-modal-cart-limit-exceed', {
          overWeight: this.vg_weightOnCart,
          modal: true,
        });
        return false;
      }

      // if( !this.vg_userId && !this.captchaVerified)  {
      //   return this.va_snackbar({
      //     type: "warning",
      //     message: 'Please verify captcha.',
      //   });
      // }



      this.va_spinner(true)
      // First check the unavailable item on cart
      let unavailableVariants = await this.checkUnavailaleItemsOfCartitems();
    
      if(unavailableVariants.modal){
        this.va_spinner(false)
        // there are some unavailable variants/ products please stop with alert
        return bus.$emit('item-no-longer-onstock', {
          modal: true,
          message: unavailableVariants.message,
        });
      }

      // Everything is good, lets create checout obj
      let pickuptime = this.vg_checkoutOrderType.pickupTime;
      // we get sometime blank pickup time 
      if(pickuptime == '') {
        // If pickup is balnk but store is open 
        if(this.vg_selectedStore.currently_open) {
          // Add 30minutes on current time
          pickuptime = Helpers.storeNowAddedTime(this.vg_selectedStore, 30);
        } else {
          // if store closed ,  // Next day opening time
          pickuptime = this.vg_checkoutOrderType.order_receive_method == 'pickup' ? Helpers.storeNextOpenDateTime(this.vg_selectedStore, 'pickup') : Helpers.storeNextOpenDateTime(this.vg_selectedStore, 'delivery');      
        }
      }

      //Prevent sending invalid time , convert to UTC
      let utcTime;
      if(pickuptime){
        moment.tz.setDefault( (this.vg_selectedStore.address && this.vg_selectedStore.address.timezone_id) ? this.vg_selectedStore.address.timezone_id : 'America/Toronto');
        let convertTime = moment(pickuptime, "YYYY-MM-DD hh:mm a").tz(this.vg_selectedStore.address && this.vg_selectedStore.address.timezone_id ? this.vg_selectedStore.address.timezone_id : 'America/Toronto');
        utcTime = convertTime.utc().format('YYYY-MM-DD HH:mm:ss');
      } else {
        utcTime = '';
      }
      
      let obj = {
        cartId: this.vg_cartId,
        // business_slug: this.$route.params.business_slug,
        receive_time: utcTime,
        pay_later: this.vg_checkoutPayment.pay_later == 1 ? true : false,
        token: this.vg_checkoutPayment.token,
        order_receive_method: this.vg_checkoutOrderType.order_receive_method,
        delivery: this.vg_checkoutOrderType.delivery,
        delivery_fee: this.vg_checkoutOrderType.delivery_fee,
        user: this.vg_checkoutOrderType.user,
        note: this.vg_checkoutOrderType.note,
      };

      // push tip is delivery order
      
      obj.tip = (this.vg_checkoutOrderType.order_receive_method == 'delivery') ? this.vg_checkoutOrderType.tip.toFixed(2) : 0;
      

      // If payment option is payasfe  then add in billing details
      if (this.vg_selectedStore.settings.payment_processor_details && (this.vg_selectedStore.settings.payment_processor_details.provider_name == 'merrco_payment') ) {
        obj.billingDetails = this.vg_checkoutPayment.billingDetails;
      }

      if ( (this.vg_checkoutPayment.pay_later == false) && (this.vg_checkoutPayment.payment_info) && this.vg_selectedStore.settings.payment_processor_details && (this.vg_selectedStore.settings.payment_processor_details.provider_name == 'fiska_payment' || this.vg_selectedStore.settings.payment_processor_details.provider_name == 'clover_payment') ) {
         obj.payment_info = {
          card_type : this.vg_checkoutPayment.payment_info.card_type,
          card_number : this.vg_checkoutPayment.payment_info.card_number,
        };
        // postal code is required for fiska but not for clover
        if(this.vg_checkoutPayment.payment_info.postal_code){
          obj.payment_info.postal_code = this.vg_checkoutPayment.payment_info.postal_code
        }
      }

    
   
      this.va_spinner(true)
      let res = await CheckoutApis.checkout(obj);
      if (res.status == 200) {
        this.orderConfirmDetail = res.data.payload;
        // G tracking purchased item
        this.$gtag.event('purchase', { 
          transaction_id: this.orderConfirmDetail.id,
          order_id: this.orderConfirmDetail.id,
          affiliation: this.orderConfirmDetail.location_id,
          value: this.orderConfirmDetail.total ? this.orderConfirmDetail.total.toFixed(2) : this.vg_checkoutOrderType.grandTotal.toFixed(2), // this is from frontend not api
          currency: "CAD",
          tax: this.orderConfirmDetail.tax ? this.orderConfirmDetail.tax : 0,
          shipping: this.vg_checkoutOrderType.delivery_fee ? this.vg_checkoutOrderType.delivery_fee  : 0,
          items: Helpers.GTagKeyValueForChekout(this.vg_cartItems),
        });
      
        // pushed to vbout 
        if(this.$store.getters.getLoggedInUserToken){
          VboutApis.createOrder(res.data.payload, this.vg_selectedStore.id)
        }
        this.va_setCartDetail({}); // double protect
        this.va_setCartId('');
        this.va_setCartItems([]);
        // If user is logged in fetch recent orders
        if (this.$store.getters.getLoggedInUserToken) {
          let orderRes = await OrderHistoryApis.fetch(1); // page 1
          if (orderRes.status == 200) {
            this.va_setAllOrders(orderRes.data.payload);
          }
        }
        this.va_resetCheckoutData();
        this.va_setSuccessObj(res.data.payload);
        // If user has change his details then update
        if(this.$store.getters.getLoggedInUserToken){
          let userDetailRes  = await UserApis.fetchUserDetail();
          if(userDetailRes.status == 200){
            // On checkout we can only update fname and lname so lets update values
            this.vm_mutateUserDetailByKeys({
              first_name: userDetailRes.data.payload.first_name,
              last_name: userDetailRes.data.payload.last_name,
              marketing_notification: userDetailRes.data.payload.marketing_notification,
            })
          }
        }
        this.va_spinner(false)

        // Push to success page
        this.$router.push({ 
          name: 'CartSuccess',
          params: {
            store_slug: this.$route.params.store_slug,
            business_slug: this.$route.params.business_slug,
          },
          query: {...this.$route.query, ...{ order_id: res.data.payload.id }}
        })
      } else if(res.response && (res.response.status == 500) ) {
        this.va_spinner(false)
        this.va_snackbar({
          type: "warning",
          message: res.response.data.msg,
        });
      } else {
        this.va_spinner(false)
        let errMessage = "Error placing order."; // We get message on different keys
        if(res.response.data){
          errMessage = Helpers.catchErrorMessage(res.response.data);
        } 
        this.va_snackbar({
          type: "warning",
          message: errMessage,
        });
      }
    },

    /**
     * Check availablility of product on stock
     */
    async checkUnavailaleItemsOfCartitems() {
      // Collect Location variant ids to pass on api to check its latest availability
      let cartItemVariantIds = _.map(this.vg_cartItems, 'location_product_variant_id');
      let checkVariantsAvailability = await ProductApis.getProductVaraintByIds(cartItemVariantIds);
      if(checkVariantsAvailability.status != 200){
        console.log('failed to check availability of variants.')
        return {
          modal: false,
          message: null,
        };  
      }
      // On success, filter and collect variants whose inventory is less than out of stock or availability false 
      let unavailableVariants = _.filter(checkVariantsAvailability.data.payload, function(o) { 
                                  return o.no_of_units <= o.inventory_threshold || o.available == false || o.discontinued == true
                                }); 
      // If there is any variants which match the reject logic
      if(unavailableVariants.length > 0){
        // Create message
       let message = 'Unfortunately the following <br/>';
        message +=  unavailableVariants.length > 1 ? 'products are no longer in stock.<br/>' : 'product is no longer in stock.<br/>';
        // foreach all variant who pass the reject logic
        unavailableVariants.forEach( async(item) => {
          let hasUnavailableVariant = _.find(this.vg_cartItems, { location_product_variant_id: item.id });
          // match the variant id on cart item to delete
          if(hasUnavailableVariant != undefined){
            // store product name size
            message += '<br/> ' + item.name;
            message += item.size ? ' Size: ' + item.size : '';
            // delete item from cart
            await CartApis.delete({
              cart_product_id: hasUnavailableVariant.id, // mean the cart service product id which is aaded per variant
              location_id: this.$store.getters['location/selected'].id ? this.$store.getters['location/selected'].id : '',
            });
          }
        })
        return {
          modal: true,
          message: message,
        }; 
      } 

      return {
        modal: false,
        message: null,
      }; 

    },

    hasSalePrice(item) {
      if(parseFloat(item.selected_variant.sale_price) > 0 && parseFloat(item.selected_variant.sale_price) < parseFloat(item.selected_variant.price)){
        return true;
      }
      return false;
    },

    ...mapMutations({
      vm_mutateUserDetailByKeys: "MUTATE_USER_DETAILS_BY_KEYS",
    }),

  
    // onVerify: function (response) {
    //   this.captchaVerified = true;
    // },
    // expiredCaptcha: function(err) {
    //   this.captchaVerified = false;
    // },

    ...mapActions({
      va_spinner: "spinner/setSpinner",
      va_snackbar: "snackbar/setSnackbar",
      va_setCartItems: "cart/setCartItems",
      va_setCartDetail: "cart/setCartDetail",
      va_setCartId: "cart/setId",
      va_setAllOrders: "orderhistory/setAllOrders",
      va_setSuccessObj: 'cart/setSuccessObj',
      va_resetCheckoutData: 'checkout/resetCheckoutData'
    })

  },
};
</script>


